import AppProviders from "./providers/AppProviders";
import AppRoutes from "./routing/AppRoutes";

function App() {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}

export default App;
